import { useTranslation } from '@common/utils';
import { useSettings } from '@common/hooks';

import defaultUniversities from '../../../Coliving/universities.json';
import defaultFaculties from '../../../Coliving/faculties.json';
import countries from '../../../Coliving/countries.json';

const defaultSourceOfDiscoveryOptions = [
	{ value: 'googleSearch', label: 'Google search' },
	{ value: 'socialMedia', label: 'Social media' },
	{ value: 'onlineAdvertisement', label: 'Online advertisement' },
	{ value: 'emailCampaign', label: 'Email campaign' },
	{ value: 'friendOrFamilyMember', label: 'Referral from a Friend or Family Member' },
	{ value: 'other', label: 'Other' },
];

function options() {
	const tr = useTranslation();

	const { universities, faculties, sourceOfDiscoveryOptions } = useSettings();

	return {
		'typeOfStudent': [
			{ value: 'exchangeFiveMonths', label: tr('Exchange (Erasmus 5 months)') },
			{ value: 'exchangeTenMonths', label: tr('Exchange (Erasmus 10 months)') },
			{ value: 'fullTime', label: tr('Full-time') },
		],
		'gender': [
			{ value: 'male', label: tr('Male') },
			{ value: 'female', label: tr('Female') },
			{ value: 'other', label: tr('Other') },
		],
		'stayPurpose': [
			{ value: 'study', label: tr('Study') },
			{ value: 'work', label: tr('Work') },
			{ value: 'leisure', label: tr('Leisure') },
		],
		'studyYear': [
			{ value: 1, label: '1' },
			{ value: 2, label: '2' },
			{ value: 3, label: '3' },
			{ value: 4, label: '4' },
			{ value: 5, label: '5' },
			{ value: 6, label: '6' },
		],
		'documentCountryCode': [
			{ value: 'ABW', label: 'ABW' },
			{ value: 'AFG', label: 'AFG' },
			{ value: 'AGO', label: 'AGO' },
			{ value: 'AIA', label: 'AIA' },
			{ value: 'ALA', label: 'ALA' },
			{ value: 'ALB', label: 'ALB' },
			{ value: 'AND', label: 'AND' },
			{ value: 'ARE', label: 'ARE' },
			{ value: 'ARG', label: 'ARG' },
			{ value: 'ARM', label: 'ARM' },
			{ value: 'ASM', label: 'ASM' },
			{ value: 'ATA', label: 'ATA' },
			{ value: 'ATF', label: 'ATF' },
			{ value: 'ATG', label: 'ATG' },
			{ value: 'AUS', label: 'AUS' },
			{ value: 'AUT', label: 'AUT' },
			{ value: 'AZE', label: 'AZE' },
			{ value: 'BDI', label: 'BDI' },
			{ value: 'BEL', label: 'BEL' },
			{ value: 'BEN', label: 'BEN' },
			{ value: 'BES', label: 'BES' },
			{ value: 'BFA', label: 'BFA' },
			{ value: 'BGD', label: 'BGD' },
			{ value: 'BGR', label: 'BGR' },
			{ value: 'BHR', label: 'BHR' },
			{ value: 'BHS', label: 'BHS' },
			{ value: 'BIH', label: 'BIH' },
			{ value: 'BLM', label: 'BLM' },
			{ value: 'BLR', label: 'BLR' },
			{ value: 'BLZ', label: 'BLZ' },
			{ value: 'BMU', label: 'BMU' },
			{ value: 'BOL', label: 'BOL' },
			{ value: 'BRA', label: 'BRA' },
			{ value: 'BRB', label: 'BRB' },
			{ value: 'BRN', label: 'BRN' },
			{ value: 'BTN', label: 'BTN' },
			{ value: 'BVT', label: 'BVT' },
			{ value: 'BWA', label: 'BWA' },
			{ value: 'CAF', label: 'CAF' },
			{ value: 'CAN', label: 'CAN' },
			{ value: 'CCK', label: 'CCK' },
			{ value: 'CHE', label: 'CHE' },
			{ value: 'CHL', label: 'CHL' },
			{ value: 'CHN', label: 'CHN' },
			{ value: 'CIV', label: 'CIV' },
			{ value: 'CMR', label: 'CMR' },
			{ value: 'COD', label: 'COD' },
			{ value: 'COG', label: 'COG' },
			{ value: 'COK', label: 'COK' },
			{ value: 'COL', label: 'COL' },
			{ value: 'COM', label: 'COM' },
			{ value: 'CPV', label: 'CPV' },
			{ value: 'CRI', label: 'CRI' },
			{ value: 'CUB', label: 'CUB' },
			{ value: 'CUW', label: 'CUW' },
			{ value: 'CXR', label: 'CXR' },
			{ value: 'CYM', label: 'CYM' },
			{ value: 'CYP', label: 'CYP' },
			{ value: 'CZE', label: 'CZE' },
			{ value: 'DEU', label: 'DEU' },
			{ value: 'DJI', label: 'DJI' },
			{ value: 'DMA', label: 'DMA' },
			{ value: 'DNK', label: 'DNK' },
			{ value: 'DOM', label: 'DOM' },
			{ value: 'DZA', label: 'DZA' },
			{ value: 'ECU', label: 'ECU' },
			{ value: 'EGY', label: 'EGY' },
			{ value: 'ERI', label: 'ERI' },
			{ value: 'ESH', label: 'ESH' },
			{ value: 'ESP', label: 'ESP' },
			{ value: 'EST', label: 'EST' },
			{ value: 'ETH', label: 'ETH' },
			{ value: 'FIN', label: 'FIN' },
			{ value: 'FJI', label: 'FJI' },
			{ value: 'FLK', label: 'FLK' },
			{ value: 'FRA', label: 'FRA' },
			{ value: 'FRO', label: 'FRO' },
			{ value: 'FSM', label: 'FSM' },
			{ value: 'GAB', label: 'GAB' },
			{ value: 'GBR', label: 'GBR' },
			{ value: 'GEO', label: 'GEO' },
			{ value: 'GGY', label: 'GGY' },
			{ value: 'GHA', label: 'GHA' },
			{ value: 'GIB', label: 'GIB' },
			{ value: 'GIN', label: 'GIN' },
			{ value: 'GLP', label: 'GLP' },
			{ value: 'GMB', label: 'GMB' },
			{ value: 'GNB', label: 'GNB' },
			{ value: 'GNQ', label: 'GNQ' },
			{ value: 'GRC', label: 'GRC' },
			{ value: 'GRD', label: 'GRD' },
			{ value: 'GRL', label: 'GRL' },
			{ value: 'GTM', label: 'GTM' },
			{ value: 'GUF', label: 'GUF' },
			{ value: 'GUM', label: 'GUM' },
			{ value: 'GUY', label: 'GUY' },
			{ value: 'HKG', label: 'HKG' },
			{ value: 'HMD', label: 'HMD' },
			{ value: 'HND', label: 'HND' },
			{ value: 'HRV', label: 'HRV' },
			{ value: 'HTI', label: 'HTI' },
			{ value: 'HUN', label: 'HUN' },
			{ value: 'IDN', label: 'IDN' },
			{ value: 'IMN', label: 'IMN' },
			{ value: 'IND', label: 'IND' },
			{ value: 'IOT', label: 'IOT' },
			{ value: 'IRL', label: 'IRL' },
			{ value: 'IRN', label: 'IRN' },
			{ value: 'IRQ', label: 'IRQ' },
			{ value: 'ISL', label: 'ISL' },
			{ value: 'ISR', label: 'ISR' },
			{ value: 'ITA', label: 'ITA' },
			{ value: 'JAM', label: 'JAM' },
			{ value: 'JEY', label: 'JEY' },
			{ value: 'JOR', label: 'JOR' },
			{ value: 'JPN', label: 'JPN' },
			{ value: 'KAZ', label: 'KAZ' },
			{ value: 'KEN', label: 'KEN' },
			{ value: 'KGZ', label: 'KGZ' },
			{ value: 'KHM', label: 'KHM' },
			{ value: 'KIR', label: 'KIR' },
			{ value: 'KNA', label: 'KNA' },
			{ value: 'KOR', label: 'KOR' },
			{ value: 'KWT', label: 'KWT' },
			{ value: 'LAO', label: 'LAO' },
			{ value: 'LBN', label: 'LBN' },
			{ value: 'LBR', label: 'LBR' },
			{ value: 'LBY', label: 'LBY' },
			{ value: 'LCA', label: 'LCA' },
			{ value: 'LIE', label: 'LIE' },
			{ value: 'LKA', label: 'LKA' },
			{ value: 'LSO', label: 'LSO' },
			{ value: 'LTU', label: 'LTU' },
			{ value: 'LUX', label: 'LUX' },
			{ value: 'LVA', label: 'LVA' },
			{ value: 'MAC', label: 'MAC' },
			{ value: 'MAF', label: 'MAF' },
			{ value: 'MAR', label: 'MAR' },
			{ value: 'MCO', label: 'MCO' },
			{ value: 'MDA', label: 'MDA' },
			{ value: 'MDG', label: 'MDG' },
			{ value: 'MDV', label: 'MDV' },
			{ value: 'MEX', label: 'MEX' },
			{ value: 'MHL', label: 'MHL' },
			{ value: 'MKD', label: 'MKD' },
			{ value: 'MLI', label: 'MLI' },
			{ value: 'MLT', label: 'MLT' },
			{ value: 'MMR', label: 'MMR' },
			{ value: 'MNE', label: 'MNE' },
			{ value: 'MNG', label: 'MNG' },
			{ value: 'MNP', label: 'MNP' },
			{ value: 'MOZ', label: 'MOZ' },
			{ value: 'MRT', label: 'MRT' },
			{ value: 'MSR', label: 'MSR' },
			{ value: 'MTQ', label: 'MTQ' },
			{ value: 'MUS', label: 'MUS' },
			{ value: 'MWI', label: 'MWI' },
			{ value: 'MYS', label: 'MYS' },
			{ value: 'MYT', label: 'MYT' },
			{ value: 'NAM', label: 'NAM' },
			{ value: 'NCL', label: 'NCL' },
			{ value: 'NER', label: 'NER' },
			{ value: 'NFK', label: 'NFK' },
			{ value: 'NGA', label: 'NGA' },
			{ value: 'NIC', label: 'NIC' },
			{ value: 'NIU', label: 'NIU' },
			{ value: 'NLD', label: 'NLD' },
			{ value: 'NOR', label: 'NOR' },
			{ value: 'NPL', label: 'NPL' },
			{ value: 'NRU', label: 'NRU' },
			{ value: 'NZL', label: 'NZL' },
			{ value: 'OMN', label: 'OMN' },
			{ value: 'PAK', label: 'PAK' },
			{ value: 'PAN', label: 'PAN' },
			{ value: 'PCN', label: 'PCN' },
			{ value: 'PER', label: 'PER' },
			{ value: 'PHL', label: 'PHL' },
			{ value: 'PLW', label: 'PLW' },
			{ value: 'PNG', label: 'PNG' },
			{ value: 'POL', label: 'POL' },
			{ value: 'PRI', label: 'PRI' },
			{ value: 'PRK', label: 'PRK' },
			{ value: 'PRT', label: 'PRT' },
			{ value: 'PRY', label: 'PRY' },
			{ value: 'PSE', label: 'PSE' },
			{ value: 'PYF', label: 'PYF' },
			{ value: 'QAT', label: 'QAT' },
			{ value: 'REU', label: 'REU' },
			{ value: 'ROU', label: 'ROU' },
			{ value: 'RUS', label: 'RUS' },
			{ value: 'RWA', label: 'RWA' },
			{ value: 'SAU', label: 'SAU' },
			{ value: 'SDN', label: 'SDN' },
			{ value: 'SEN', label: 'SEN' },
			{ value: 'SGP', label: 'SGP' },
			{ value: 'SGS', label: 'SGS' },
			{ value: 'SHN', label: 'SHN' },
			{ value: 'SJM', label: 'SJM' },
			{ value: 'SLB', label: 'SLB' },
			{ value: 'SLE', label: 'SLE' },
			{ value: 'SLV', label: 'SLV' },
			{ value: 'SMR', label: 'SMR' },
			{ value: 'SOM', label: 'SOM' },
			{ value: 'SPM', label: 'SPM' },
			{ value: 'SRB', label: 'SRB' },
			{ value: 'SSD', label: 'SSD' },
			{ value: 'STP', label: 'STP' },
			{ value: 'SUR', label: 'SUR' },
			{ value: 'SVK', label: 'SVK' },
			{ value: 'SVN', label: 'SVN' },
			{ value: 'SWE', label: 'SWE' },
			{ value: 'SWZ', label: 'SWZ' },
			{ value: 'SXM', label: 'SXM' },
			{ value: 'SYC', label: 'SYC' },
			{ value: 'SYR', label: 'SYR' },
			{ value: 'TCA', label: 'TCA' },
			{ value: 'TCD', label: 'TCD' },
			{ value: 'TGO', label: 'TGO' },
			{ value: 'THA', label: 'THA' },
			{ value: 'TJK', label: 'TJK' },
			{ value: 'TKL', label: 'TKL' },
			{ value: 'TKM', label: 'TKM' },
			{ value: 'TLS', label: 'TLS' },
			{ value: 'TON', label: 'TON' },
			{ value: 'TTO', label: 'TTO' },
			{ value: 'TUN', label: 'TUN' },
			{ value: 'TUR', label: 'TUR' },
			{ value: 'TUV', label: 'TUV' },
			{ value: 'TWN', label: 'TWN' },
			{ value: 'TZA', label: 'TZA' },
			{ value: 'UGA', label: 'UGA' },
			{ value: 'UKR', label: 'UKR' },
			{ value: 'UMI', label: 'UMI' },
			{ value: 'URY', label: 'URY' },
			{ value: 'USA', label: 'USA' },
			{ value: 'UZB', label: 'UZB' },
			{ value: 'VAT', label: 'VAT' },
			{ value: 'VCT', label: 'VCT' },
			{ value: 'VEN', label: 'VEN' },
			{ value: 'VGB', label: 'VGB' },
			{ value: 'VIR', label: 'VIR' },
			{ value: 'VNM', label: 'VNM' },
			{ value: 'VUT', label: 'VUT' },
			{ value: 'WLF', label: 'WLF' },
			{ value: 'WSM', label: 'WSM' },
			{ value: 'YEM', label: 'YEM' },
			{ value: 'ZAF', label: 'ZAF' },
			{ value: 'ZMB', label: 'ZMB' },
			{ value: 'ZWE', label: 'ZWE' },
		],
		'purposeOfTravel': [
			{ value: 'LEISURE', label: tr('Leisure') },
			{ value: 'WORK', label: tr('Work') },
			{ value: 'HEALTH', label: tr('Health') },
			{ value: 'OTHER', label: tr('Other') },
		],
		'universityName': universities.length > 0 ? universities : defaultUniversities,
		'faculty': faculties.length > 0 ? faculties : defaultFaculties,
		'country': countries,
		'sourceOfDiscovery': sourceOfDiscoveryOptions.length > 0 ? sourceOfDiscoveryOptions : defaultSourceOfDiscoveryOptions,
	};
}

export default options;
